// CountDown Clock (vanilla)
// Ported from https://github.com/epiksel/countdown

function countdownTimer(selector, options, callback) {
  var container = document.querySelector(selector);
  if (!container) return;

  var target = new Date(options.date);

  function currentDate() {
    var date = new Date();
    var utc = date.getTime() + date.getTimezoneOffset() * 60000;
    return new Date(utc + 3600000 * options.offset);
  }

  function pad(n) {
    return String(n).length >= 2 ? n : '0' + n;
  }

  function tick() {
    var difference = target - currentDate();

    if (difference < 0) {
      clearInterval(interval);
      if (typeof callback === 'function') callback();
      return;
    }

    var day = 1000 * 60 * 60 * 24;
    var hour = 1000 * 60 * 60;
    var minute = 1000 * 60;
    var second = 1000;

    var days = Math.floor(difference / day);
    var hours = Math.floor((difference % day) / hour);
    var minutes = Math.floor((difference % hour) / minute);
    var seconds = Math.floor((difference % minute) / second);

    var daysEl = container.querySelector('.days');
    var hoursEl = container.querySelector('.hours');
    var minutesEl = container.querySelector('.minutes');
    var secondsEl = container.querySelector('.seconds');
    if (daysEl) daysEl.textContent = pad(days);
    if (hoursEl) hoursEl.textContent = pad(hours);
    if (minutesEl) minutesEl.textContent = pad(minutes);
    if (secondsEl) secondsEl.textContent = pad(seconds);
  }

  var interval = setInterval(tick, 1000);
}
